import querystring from 'query-string';
import { GeocodeAttributes } from 'types/Geocode';
import Make from 'types/Make';

import Model from 'types/Model';
import SearchParams from 'types/Apis/SearchParams';
import * as _ from 'lodash-es';
import WindowLocation from 'lib/WindowLocation';
import { omitUndefined } from './utils';

export class SearchUrl {
  constructor(private search: Search) {
    this.search = search;
  }

  get url(): URL {
    const params = this.search.queryParams;

    const hashParamString = querystring.stringify(
      { ...params },
      {
        arrayFormat: 'bracket',
      }
    );

    const url = new URL(`/listings`, window.location.origin);

    url.hash = hashParamString;

    return url;
  }
}

export default class Search {
  make?: Make;

  trim?: string[];

  model?: Make;

  bodyType?: string;

  location?: GeocodeAttributes;

  priceMin?: number;

  priceMax?: number;

  radius?: number;

  constructor({
    make,
    model,
    trim,
    location,
    bodyType,
    priceMin,
    priceMax,
    radius,
  }: {
    trim?: string[];
    make?: Make;
    model?: Model;
    location?: GeocodeAttributes;
    bodyType?: string;
    priceMin?: number;
    priceMax?: number;
    radius?: number;
  }) {
    this.make = make;
    this.model = model;
    this.location = location;
    this.bodyType = bodyType;
    this.priceMax = priceMax;
    this.priceMin = priceMin;
    this.trim = trim;
    this.radius = radius;
  }

  get queryParams(): SearchParams {
    const allParams: SearchParams = {
      city: this.location?.city,
      state: this.location?.stateAbbreviation,
      latitude: this.location?.latitude,
      longitude: this.location?.longitude,
      make: this.make?.name,
      model: this.model?.name,
      // body_style[] is named thus in order to accommodate the url param name which core expects
      'body_style[]': this.bodyType,
      price_min: this.priceMin,
      price_max: this.priceMax,
      trim: this.trim,
      radius: this.radius,
    };
    return omitUndefined(allParams) as SearchParams;
  }

  get url(): URL {
    return new SearchUrl(this).url;
  }
}

function performSearch(search: Search, push: (url: string) => void): void {
  const { url } = search;

  const utmParams = _.pickBy(querystring.parse(WindowLocation.search), (_value, key): boolean => {
    return key.startsWith('utm_') || key === 'p';
  });

  url.search = querystring.stringify(utmParams);

  push(`${url.pathname}${url.search}${url.hash}`);
}

export { performSearch };
